import { Injectable } from "@angular/core";
import { IID_OLO_DEACTIVATION_VALIDATION } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolDeactivationValidationStore } from "./iidOlDeactivationValidation.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';


@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.OLO_DEACTIVATION_VALIDATION)
export class IIDolDeactivationValidationQuery extends AbstractInterfaceDataQuery<IID_OLO_DEACTIVATION_VALIDATION> {

  constructor(protected store: IIDolDeactivationValidationStore) {
    super(store);
  }
}
